module.exports = __webpack_public_path__ + "static/media/Id_Logo.eba81843.svg";